import { createRouter, createWebHistory } from 'vue-router'
//import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/about/AboutView.vue'
//import ArticleView from '../views/about/ArticleView.vue'
import XiSanView from '../views/xisan/XiSanAboutView.vue'//西山落地页，推广页
import basic_analyse from '../views/basic_analyse/BasicAnalyseView.vue'//检前分析
import pre_exam from '../views/examination/PreExamView.vue'//检前调研
//套餐建议
import pre_project_ad from '../views/basic_analyse/PreProjectAdView.vue'

import chmed_exam from '../views/ch_medicine_phys/chMedicinePhys.vue'//中医体质问题
import chmed_analyse from '../views/ch_medicine_phys/chMedAnalyseView.vue'//中医体质分析
import user_health_info from '../views/user_health/RegisterView.vue'//个人信息中心
import user_banding from '../views/user_health/RegisterMid.vue'//绑定中
import hosp_banding from '../views/user_health/UserInfoView.vue'//机构绑定
import informed_consent  from '../views/user_binding/informedConsentView.vue'//知情同意书
import product_list  from '../views/product_order/productListView.vue'//产品列表
import product_desc  from '../views/product_order/ProductDesView.vue'//产品详情
import product_order  from '../views/product_order/PersonOrderView.vue'//产品支付页
import cacs_analyse  from  '../views/cacs/CardiovascularView.vue'//心脏分析
import data_center from '../views/person_data/NewDataListView.vue'//个人数据中心
import add_user_data from '../views/person_data/AddUserDataView.vue'//手动新增数据，药房模式
import binding_hosp from '../views/binding/BindingInfoView.vue'//机构邀请
import binding_step_hosp from '../views/binding/BindingStep0View.vue'//机构邀请0
import binding_step1_hosp from '../views/binding/BindingStep1View.vue'//机构邀请1
import binding_step11_hosp from '../views/binding/BindingStep11View.vue'//机构邀请11,药房路径
import binding_step2_hosp from '../views/binding/BindingStep2View.vue'//机构邀请2
import binding_hosp_login from '../views/binding/BindingHospLogin.vue'//机构绑定登陆
import user_order from '../views/user_health/UserOrderView.vue'//机构邀请
import privacy_agreement  from '../views/user_binding/privacyAgreementView.vue'//隐私协议
import user_service_agreement  from '../views/user_binding/userServiceAgreementView.vue'//用户服务协议

//支付规划
import user_finance  from '../views/finance/userFinanceView.vue'//用户服务协议
//医生端
import doctor_index from '../views/doctor/doctorIndex.vue'//医生首页
import doctor_work from '../views/doctor/doctorWork.vue'//医生首页
import hosp_User from '../views/doctor/hospUserView.vue'//体检科
import hosp_Bi from '../views/doctor/hospBiView.vue'//数据分析
import user_health_des from '../views/doctor/userCardiovascularView.vue'//医生首页
import zhongyike_des  from  '../views/cacs/ZhongyikeView.vue'//中医科介绍

//文章
import article_list from '../views/article/ArticleListView.vue'
import article from '../views/article/ArticleView.vue'

//验证一下
const routes = [
  {
    path: '/',
    name: 'home',
    meta:{
      title: '关于我们'       //title配置
    },
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    meta:{
      title: '项目介绍'       //title配置
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  //{
  //  path: '/article',
  //  name: 'article',
  //  meta:{
  //    title: '文章介绍'       //title配置
   // },
  //  component: ArticleView
  //},
  {
    path: '/XiSan',
    name: 'XiSan',
    meta:{
      title: '西山医院邀请'       //title配置
    },
    component: XiSanView
  },
  {
    path: '/basicAnalyse',
    name: 'basicAnalyse',
    meta:{
      title: '个人身体概况分析'       //title配置
    },
    component: basic_analyse
  },
  {
    path: '/preProjectAd',
    name: 'preProjectAd',
    meta:{
      title: '体检套餐建议'       //title配置
    },
    component: pre_project_ad
  },
  {
    path: '/cardiovascular',
    name: 'cardiovascular',
    meta:{
      title: '心脏健康'       //title配置
    },
    component: cacs_analyse
  },
  {
    path: '/informedConsent', 
    name: 'informedConsent',
    meta:{
      title: '知情同意书'       //title配置
    },
    component: informed_consent
  },
  {
    path: '/privacyAgreement', 
    name: 'privacyAgreement',
    meta:{
      title: '隐私服务协议'       //title配置
    },
    component: privacy_agreement
  },
  {
    path: '/userServiceAgreement', 
    name: 'userServiceAgreement',
    meta:{
      title: '用户服务协议'       //title配置
    },
    component: user_service_agreement
  },
  {
    path: '/register',
    name: 'register',
    meta:{
      title: '个人信息'       //title配置
    },
    component: user_health_info
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    meta:{
      title: '医疗机构绑定' 
    },
    component: hosp_banding
  },
  {
    path: '/registerMid',
    name: 'registerMid',
    meta:{
      title: '机构绑定中'       //title配置
    },
    component: user_banding
  },
  {
    path: '/chmed',
    name: 'chmed',
    meta:{
      title: '中医体质'       //title配置
    },
    component: chmed_exam
  },
  {
    path: '/chmedAnalyse',
    name: 'chmedAnalyse',
    meta:{
      title: '体质结果'       //title配置
    },
    component: chmed_analyse
  },
  {
    path: '/dataCenterList',
    name: 'dataCenterList',
    meta:{
      title: '检查数据列表'       //title配置
    },
    component: data_center
  },
  {
    path: '/addUserData',
    name: 'addUserData',
    meta:{
      title: '手动新增数据'       //title配置
    },
    component: add_user_data
  },
  {
    path: '/personAction',
    name: 'personAction',
    meta:{
      title: '个人健康信息采集'       //title配置
    },
    component: pre_exam
  },
  {
    path: '/personOrder/:productCode',
    name: 'personOrder',
    meta:{
      title: '订单支付'       //title配置
    },
    component: product_order
  },
  {
    path: '/productDes/:productCode',
    name: 'productDes',
    meta:{
      title: '产品详细介绍'       //title配置
    },
    component: product_desc
  },
  {
    path: '/productList',
    name: 'productList',
    meta:{
      title: '产品服务列表'       //title配置
    },
    component: product_list
  },
  {
    path: '/bindingHosp',
    name: 'bindingHosp',
    meta:{
      title: '机构邀请'       //title配置
    },
    component: binding_hosp
  },
  {
    path: '/bindingStepHosp',
    name: 'bindingStepHosp',
    meta:{
      title: '机构分步邀请'       //title配置
    },
    component: binding_step_hosp
  },
  {
    path: '/bindingStepHosp1',
    name: 'bindingStepHosp1',
    meta:{
      title: '机构分步邀请'       //title配置
    },
    component: binding_step1_hosp
  },
  {
    path: '/bindingStepHosp11',
    name: 'bindingStepHosp11',
    meta:{
      title: '机构分步邀请'       //药房路径
    },
    component: binding_step11_hosp
  },
  {
    path: '/bindingStepHosp2',
    name: 'bindingStepHosp2',
    meta:{
      title: '机构分步邀请'       //title配置
    },
    component: binding_step2_hosp
  },
  {
    path: '/bindingHospLogin',
    name: 'bindingHospLogin',
    meta:{
      title: '登陆'       //title配置
    },
    component: binding_hosp_login
  },
  {
    path: '/userOrder',
    name: 'userOrder',
    meta:{
      title: '服务订单'       //title配置
    },
    component: user_order
  },
  {
    path: '/doctorIndex',
    name: 'doctorIndex',
    meta:{
      title: '医生查看列表'       //title配置
    },
    component: doctor_index
  },
  {
    path: '/userHealthDes/:wxOpenId',
    name: 'userHealthDes',
    meta:{
      title: '客户心脏健康详情'       //title配置
    },
    component: user_health_des
  },
  {
    path: '/doctorWork',
    name: 'doctorWork',
    meta:{
      title: '医生计划'       //title配置
    },
    component: doctor_work
  },
  {
    path: '/hospUser',
    name: 'hospUser',
    meta:{
      title: '体检科'       //title配置
    },
    component: hosp_User
  },
  {
    path: '/hospBi',
    name: 'hospBi',
    meta:{
      title: '数据分析'       //title配置
    },
    component: hosp_Bi
  },
  {
    path: '/userFinance',
    name: 'userFinance',
    meta:{
      title: '会算账'       //title配置
    },
    component: user_finance
  },
  {
    path: '/zhongyike/:hospId',
    name: 'zhongyike',
    meta:{
      title: '中医相关科室'       //title配置
    },
    component: zhongyike_des
  },
  {
    path: '/articleList',
    name: 'articleList',
    meta:{
      title: '消息盒子'       //title配置
    },
    component: article_list
  },
  {
    path: '/article',
    name: 'article',
    meta:{
      title: '消息内容'       //title配置
    },
    component: article
  },
  
]
const router = createRouter({
  history: createWebHistory(),
  //history: createWebHashHistory(),
  routes
})
export default router
